/**
 * `checkbox` → **Customize Checkbox column** (card P-123).
 *
 * The capture reaches the row and stops there: `editors/checkbox/settings-dialog.json` is the
 * `Settings` **submenu**, whose first row is *Customize Checkbox column*, and the dialog behind
 * it was never opened. So its contents are taken from the store instead of guessed:
 * `checkboxSettingsSchema` is `{color, hide_footer}` `[09§A.7 checkbox]`, and `color` is the tick's
 * colour — which is what the cell paints.
 *
 * Card P-123 lists "the label beside the tick" as the thing monday configures here. No capture
 * shows it, `[09§A.7]` documents no key for it and `settings_str` has none on any checkbox column
 * of this account `[cvs§2]`, so no such field is invented (CLAUDE.md rule 3) — q521.
 */
import type { CheckboxSettings } from '@elizmonday/shared';
import { ColorSwatches, HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function CheckboxSettingsDialog({
  settings,
  onCommit,
  onCancel,
}: ColumnSettingsProps<CheckboxSettings>) {
  const [draft, patch] = useSettingsDraft<CheckboxSettings>(settings);
  return (
    <SettingsForm
      title="Checkbox column settings"
      testId="checkbox-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <ColorSwatches
        testId="checkbox-color"
        value={draft.color}
        onChange={(hex) => patch({ color: hex })}
      />
      <HideSummaryField
        testId="checkbox-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
